const GET_USER_ACTIVITY = 'core/userActivity/GET_USER_ACTIVITY';
const GET_USER_ACTIVITY_COMPLETED = 'core/userActivity/GET_USER_ACTIVITY_COMPLETED';
const GET_USER_ACTIVITY_FAILED = 'core/userActivity/GET_USER_ACTIVITY_FAILED';

const GET_MESSAGES_UNREAD = 'core/userActivity/GET_MESSAGES_UNREAD';
const GET_MESSAGES_UNREAD_COMPLETED = 'core/userActivity/GET_MESSAGES_UNREAD_COMPLETED';
const GET_MESSAGES_UNREAD_FAILED = 'core/userActivity/GET_MESSAGES_UNREAD_FAILED';

const GET_FREQUENCIES = 'core/userActivity/GET_FREQUENCIES';
const GET_FREQUENCIES_COMPLETED = 'core/userActivity/GET_FREQUENCIES_COMPLETED';
const GET_FREQUENCIES_FAILED = 'core/userActivity/GET_FREQUENCIES_FAILED';

const PUT_USER_ACTIVITY = 'core/userActivity/PUT_USER_ACTIVITY';
const PUT_USER_ACTIVITY_COMPLETED = 'core/userActivity/PUT_USER_ACTIVITY_COMPLETED';
const PUT_USER_ACTIVITY_FAILED = 'core/userActivity/PUT_USER_ACTIVITY_FAILED';

const POST_USER_ACTIVITY = 'core/userActivity/POST_USER_ACTIVITY';
const POST_USER_ACTIVITY_COMPLETED = 'core/userActivity/POST_USER_ACTIVITY_COMPLETED';
const POST_USER_ACTIVITY_FAILED = 'core/userActivity/POST_USER_ACTIVITY_FAILED';

const DELETE_USER_ACTIVITY = 'core/userActivity/DELETE_USER_ACTIVITY';
const DELETE_USER_ACTIVITY_COMPLETED = 'core/userActivity/DELETE_USER_ACTIVITY_COMPLETED';
const DELETE_USER_ACTIVITY_FAILED = 'core/userActivity/DELETE_USER_ACTIVITY_FAILED';

export {
  GET_USER_ACTIVITY,
  GET_USER_ACTIVITY_COMPLETED,
  GET_USER_ACTIVITY_FAILED,
  PUT_USER_ACTIVITY,
  PUT_USER_ACTIVITY_COMPLETED,
  PUT_USER_ACTIVITY_FAILED,
  POST_USER_ACTIVITY,
  POST_USER_ACTIVITY_COMPLETED,
  POST_USER_ACTIVITY_FAILED,
  DELETE_USER_ACTIVITY,
  DELETE_USER_ACTIVITY_COMPLETED,
  DELETE_USER_ACTIVITY_FAILED,
  GET_FREQUENCIES,
  GET_FREQUENCIES_COMPLETED,
  GET_FREQUENCIES_FAILED,
  GET_MESSAGES_UNREAD,
  GET_MESSAGES_UNREAD_COMPLETED,
  GET_MESSAGES_UNREAD_FAILED
};
